const getters = {
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  nickname: state => state.user.name,
  welcome: state => state.user.welcome,
  roles: state => state.user.roles,
  userInfo: state => state.user.info,
  router: state => state.user.router,
  noInboundOrderCount: state => state.inboundReminder.noInboundOrderCount,
  noInboundOrderUpdatedAt: state => state.inboundReminder.noInboundOrderUpdatedAt,
}

export default getters
